import { Injectable } from '@angular/core';
import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';
import { Subject, ReplaySubject, Observable } from 'rxjs';
import { SharedDataService } from './shared-data.service';

const oAuthConfig: AuthConfig = {
  issuer: 'https://accounts.google.com',
  strictDiscoveryDocumentValidation: false,
  redirectUri: window.location.origin,
  clientId: window.location.href !== 'http://localhost:4200/' && window.location.href !== 'http://localhost:4200/#/login' ? '700227042414-ejfugad8d8ipncvu45laja0jil60f2ko.apps.googleusercontent.com' :'781026508597-fmi6i0uss88fec0csgpt56af2nq5p01d.apps.googleusercontent.com',
  scope: 'openid profile email'
}

export interface UserInfo {
  info: {
    sub: string,
    email: string,
    name: string
  }
}

@Injectable()
export class GoogleApiService {

  userProfileSubject = new Subject<UserInfo>()

  private auth2: gapi.auth2.GoogleAuth
  private subject = new ReplaySubject<gapi.auth2.GoogleUser>(1)

  constructor(
    private readonly oAuthService: OAuthService,
    private sharedDataService: SharedDataService,
  ) {
    let local = 'http://localhost:4200/#/login';
    let local2 = 'http://localhost:4200/';
    let googleAPI = '781026508597-fmi6i0uss88fec0csgpt56af2nq5p01d.apps.googleusercontent.com';
    if (window.location.href !== local && window.location.href !== local2) {
      googleAPI = '700227042414-ejfugad8d8ipncvu45laja0jil60f2ko.apps.googleusercontent.com';
    }
    gapi.load('auth2', () => {
      this.auth2 = gapi.auth2.init({
        client_id: googleAPI
      })
    })    
   }

   signIn(){
    this.oAuthService.configure(oAuthConfig);
    this.oAuthService.loadDiscoveryDocument().then( () => {
      this.oAuthService.tryLogin().then( () => {
        if (!this.oAuthService.hasValidIdToken()) {
          this.oAuthService.initImplicitFlow()
        }
        else{
          this.oAuthService.loadUserProfile().then( (userProfile) =>{
            this.sharedDataService.celebrate(userProfile);
            
            this.userProfileSubject.next(userProfile as UserInfo)
          })
        }
      })
    })
   }

   signIn2(){
    this.auth2.signIn().then(user => {
      this.subject.next(user);
      
    }).catch((err) =>{
      
      this.subject.next(null);
    })
   }

   public observable() : Observable<gapi.auth2.GoogleUser>{
     return this.subject.asObservable()
   }

   isLoggedIn():boolean{
     return this.oAuthService.hasValidAccessToken();
   }

   signOut(){
     this.oAuthService.logOut();
   }

}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/google-api.service.ts